import { atom } from "jotai";

import { ManualPaymentStatus } from "@whoosh/features/src/Restrictions/hooks/useValidateBookingRules/__generated__/useValidateBookingRulesMutation.graphql";

import { currentBookingAtom } from "../../stores";

export const setPaymentStatusOnGuestRoundAtom = atom(
  null,
  (
    get,
    set,
    {
      roundId,
      manualPaymentStatus,
    }: { roundId: string; manualPaymentStatus: ManualPaymentStatus }
  ) => {
    const currentBooking = get(currentBookingAtom);
    if (!currentBooking) {
      return;
    }
    const updatedRounds = currentBooking.rounds.map((round) => {
      if (round.localId === roundId) {
        return {
          ...round,
          manualPaymentStatus,
        };
      }
      return round;
    });
    const newBooking = {
      ...currentBooking,
      rounds: updatedRounds,
    };
    set(currentBookingAtom, newBooking);
  }
);
